import _createClass from "C:/Users/Mariana Costa/MyProjects/my-personal-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "C:/Users/Mariana Costa/MyProjects/my-personal-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
export var ExternalInteractorBase = /*#__PURE__*/_createClass(function ExternalInteractorBase(container) {
  _classCallCheck(this, ExternalInteractorBase);
  this.container = container;
  this.type = 0;
});